import React from 'react'
import HomeComponent from '../Home/HomeComponent'

function Abouts() {
  return (
    <div>
        <HomeComponent />
    </div>
  )
}

export default Abouts